import React from "react";

function Footer() {
  return (
    <div className="text-center p-6 footer">
      <span color="#6B6E70">&copy; 2022 Copyright - </span>
      <a className="font-bold" href="https://github.com/talha442">
        Talha Faisal
      </a>
    </div>
  );
}
export default Footer;